export default __webpack_public_path__ + "static/identity-share-feccab6e920b5d50b1974a9e8700a14d.jpg";